/*
 * Adds the languages served on other domains (snus-shop.pl, snus-shop.gr, ...) to the language switcher.
 * Shopify only lists the current market's languages in Liquid, but it prints a <link rel="alternate" hreflang>
 * for every language and domain of the current page, so new domains with an assigned language show up here
 * without any theme change, and each link lands on the same page in the other language.
 */
(() => {
  const baseLanguage = (code) => code.toLowerCase().split('-')[0];

  // One target per language. Prefer a country-specific domain (pl-PL) over the generic subfolder (pl).
  const alternates = new Map();
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((link) => {
    const lang = link.hreflang.toLowerCase();
    if (lang === 'x-default') return;

    const base = baseLanguage(lang);
    if (!alternates.has(base) || lang.includes('-')) {
      alternates.set(base, { lang, href: link.href });
    }
  });

  if (alternates.size === 0) return;

  const languageName = (base) => {
    try {
      const name = new Intl.DisplayNames([base], { type: 'language' }).of(base);
      return name.charAt(0).toLocaleUpperCase(base) + name.slice(1);
    } catch (error) {
      return base.toUpperCase();
    }
  };

  document.querySelectorAll('[data-locale-selector]').forEach((selector) => {
    const popoverId = selector.querySelector('[aria-controls]')?.getAttribute('aria-controls');
    const listbox = (popoverId && document.getElementById(popoverId) || selector).querySelector('x-listbox');
    if (!listbox) return;

    const marketLanguages = new Set(
      Array.from(listbox.querySelectorAll('[name="locale_code"]'), (option) => baseLanguage(option.value))
    );

    alternates.forEach((alternate, base) => {
      if (marketLanguages.has(base)) return;

      const url = new URL(alternate.href);
      // Keep the search query, variant, etc. on the other domain
      if (!url.search && window.location.search) {
        url.search = window.location.search;
      }

      const option = document.createElement('a');
      option.className = 'popover-listbox__option';
      option.setAttribute('role', 'option');
      option.href = url.href;
      option.hreflang = alternate.lang;
      option.lang = base;
      option.textContent = languageName(base);
      listbox.appendChild(option);
    });

    if (listbox.querySelectorAll('[role="option"]').length > 1) {
      selector.hidden = false;
      selector.closest('[data-locale-selector-wrapper]')?.removeAttribute('hidden');
    }
  });
})();
